// 個人化等第制成績設定（instruction-personalization-gpa-score-setting）的 mock 題目。
//
// legacy：personalizationGPATab.jsp:134-153 以 `fieldList`（server 端 model attribute；來源 Controller
// 不在 src/ePortfolio，見 JF-147）逐題輸出單選，題目與選項來自表單範本欄位。舊版測試資料庫的 fieldList 為空，
// 實機只剩頁籤與儲存鈕，所以題目文字無實機可抄。
// 雛形用通用題目 1～13（選項 A／B／C）；13 題＝personalizationGPATab.jsp:57 `radios.length != 13` 的必填題數。
// 【雛形值待實機校準】

export interface GpaOption {
  readonly fieldOptionId: number;
  readonly name: string;
}

export interface GpaField {
  readonly formTemplateVersionFieldId: number;
  readonly fieldTypeId: number;
  readonly title: string;
  readonly items: readonly GpaOption[];
}

/** personalizationGPATab.jsp:57：每個頁籤必須剛好選滿的題數。 */
export const GPA_REQUIRED_COUNT = 13;

export const GPA_FIELDS: readonly GpaField[] = Array.from(
  { length: GPA_REQUIRED_COUNT },
  (_, index) => {
    const no = index + 1;
    return {
      formTemplateVersionFieldId: 1000 + no,
      fieldTypeId: 100 + no,
      title: `題目 ${no}`,
      items: ['A', 'B', 'C'].map((name, optionIndex) => ({
        fieldOptionId: no * 10 + optionIndex + 1,
        name,
      })),
    };
  },
);

/** personalizationGPASetting.jsp:91-104 的 7 個等第頁籤（scoreTag 1～7）。 */
export const GPA_SCORES: readonly { readonly scoreTag: number; readonly score: string }[] = [
  'A++',
  'A+',
  'A',
  'A-',
  'B',
  'C',
  'D',
].map((score, index) => ({ scoreTag: index + 1, score }));
